"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.combineEvents = combineEvents;
exports.createEventBus = createEventBus;

var _Slot = require("./Slot");

var _Transport = require("./Transport");

function combineEvents(_c1, _c2, _c3, _c4, _c5, _c6, _c7, _c8, _c9, _c10, _c11, _c12, _c13, _c14, _c15, _c16, _c17, _c18, _c19, _c20, _c21, _c22, _c23, _c24) {
  const args = Array.from(arguments);
  const keys = args.reduce((acc, arg) => {
    acc.push.apply(acc, Object.keys(arg));
    return acc;
  }, []);
  const uniqKeys = [...new Set(keys)];

  if (keys.length > uniqKeys.length) {
    throw new Error('ts-event-bus: duplicate slots encountered in combineEvents.');
  }

  return Object.assign({}, ...args);
}

function createEventBus(args) {
  const transports = (args.channels || []).map(c => new _Transport.Transport(c));
  const eventBus = {};

  for (const event in args.events) {
    if (args.events.hasOwnProperty(event)) {
      eventBus[event] = (0, _Slot.connectSlot)(event, transports, args.events[event].config);
    }
  }

  return eventBus;
}